import { useNavigate } from "react-router-dom";
import { Egg, Truck, ArrowLeft, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ThemeToggle } from "@/components/ThemeToggle";

const SUB = [
  { key: "yonetim", path: "/kumes", title: "Kümes Yönetimi", desc: "Üretim, yem, ilaç, randıman, kümes medya ve stok öngörüleri.", icon: Egg, tone: "bg-primary/10 text-primary" },
  { key: "satis", path: "/satis-panel", title: "Kümes Satış", desc: "Satış kontrol paneli, satış (sevkiyat) ve depolar arası transfer işlemleri.", icon: Truck, tone: "bg-green-500/10 text-green-600" },
];

export default function KumesSelect() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6 pt-safe-20" data-testid="kumes-select">
      <div className="absolute mt-safe-5 right-5 flex items-center gap-3 text-sm text-muted-foreground">
        <span>{user?.name || user?.email}</span>
        <ThemeToggle testid="kumes-theme-toggle" />
        <button onClick={logout} data-testid="kumes-logout" className="inline-flex items-center gap-1.5 hover:text-foreground transition-colors"><LogOut size={15} /> Çıkış</button>
      </div>
      <button onClick={() => navigate("/")} data-testid="kumes-back-modules"
        className="absolute mt-safe-5 left-5 inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors">
        <ArrowLeft size={16} /> Modüller
      </button>
      <div className="text-center mb-10">
        <h1 className="font-head text-4xl sm:text-5xl font-bold tracking-tight">Kümes</h1>
        <p className="text-muted-foreground mt-2 text-base">Lütfen çalışmak istediğiniz bölümü seçin</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-3xl">
        {SUB.map((m) => (
          <button key={m.key} onClick={() => navigate(m.path)} data-testid={`kumes-sub-${m.key}`}
            className="group w-full h-full rounded-2xl border border-border bg-card p-8 text-left transition-[border-color,box-shadow] hover:border-primary hover:shadow-xl">
            <div className={`h-14 w-14 rounded-xl flex items-center justify-center mb-5 transition-transform ${m.tone} group-hover:scale-105`}><m.icon size={28} /></div>
            <div className="font-head text-2xl font-semibold mb-1">{m.title}</div>
            <p className="text-sm text-muted-foreground">{m.desc}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
